"use client"
import React, { useState, useEffect } from "react"
import Carousel from "../components/carousel"
import constructionSteps from "./constructionSteps.json"
import { useDarkMode } from "../darkModeContext"
import { useTranslation } from "react-i18next"

export default function StepModal({
    id,
    stepID,
    currentStepID,
    setCurrentStepID,
}) {
    const { t } = useTranslation("constructionSteps")
    const isDarkMode = useDarkMode()

    const handleNextStep = () => {
    // Find the index of the current stepID
    const currentIndex = constructionSteps.findIndex(
        (item) => item.stepID === currentStepID
    )

    // If the next item exists, move to the next step, otherwise go to the first step (loop)
    if (currentIndex !== -1) {
      const nextIndex = (currentIndex + 1) % constructionSteps.length // Loop back to the first step
        const nextItem = constructionSteps[nextIndex]
        setCurrentStepID(nextItem.stepID)
    }
}

    const handlePrevStep = () => {
    // Find the index of the current stepID
    const currentIndex = constructionSteps.findIndex(
        (item) => item.stepID === currentStepID
    )

    // If the previous item exists, move to the previous step, otherwise go to the last step (loop)
    if (currentIndex !== -1) {
        const prevIndex =
        (currentIndex - 1 + constructionSteps.length) % constructionSteps.length // Loop back to the last step
        const prevItem = constructionSteps[prevIndex]
        setCurrentStepID(prevItem.stepID)
    }
    }

    return (
    <div
        className="modal relative fade slide-in-bottom w-[100vw] h-full"
        id={id}
        tabIndex="-1"
        aria-labelledby={`${id}Label`}
        aria-hidden="true"
    >
        <div
        className={`modal-dialog mt-[5vw] rounded-lg ${
            isDarkMode ? "bg-dark" : "bg-white"
        } h-[calc(100%-5vw)] w-[90vw] mx-[5vw]`}
        >
        <div className="modal-content h-[100%] w-[90vw] relative flex flex-col">
          {/* Close Button */}
            <button
            type="button"
            className="btn-close absolute top-6 right-8 z-[1100]"
            data-bs-dismiss="modal"
            aria-label="Close"
            ></button>
            <h2 className="mt-14 md:mt-20 mb-[2rem] px-[5vw] text-xl text-left font-bold landscape-md:hidden">
                {t(`${currentStepID}.title`)}
            </h2>

            <div className="flex flex-col lg:flex-row h-full mt-[0px] landscape-md:mt-20 px-[5vw] md:gap-[5vw] overflow-y-auto">
            {/* Carousel Section */}

            <div className="landscape-md:w-6/12 h-auto portrait-md:h-2/3">
                <Carousel
                type="constructionSteps"
                stepID={currentStepID ? currentStepID : "acheminement"}
                />
            </div>

            {/* Text Section */}
            <div className="flex-grow text-left font-montserrat">
                <h2 className="mb-4 text-xl font-bold hidden landscape-md:block">
                {t(`${currentStepID}.title`)}
                </h2>
                <p className="mb-6 mt-6 md:mt-0 overflow-y-auto pr-2">{t(`${currentStepID}.content`)}</p>
                <div className="mt-auto">
                <p className="text-right text-sm">
                    {t(`${currentStepID}.date`)}
                </p>
                <hr className="mt-2 mb-2 ml-auto w-40 border-4 border-blue" />
                </div>
            </div>
            </div>

          {/* SVG and Next Section */}
            <div className="modal-footer position-relative w-full px-0 md:px-0 bg-transparent">
            <svg
                className="w-[100vw]"
                id="wave"
                style={{ transform: "rotate(0deg)", transition: "0.3s" }}
                viewBox="0 0 1800 90"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
            >
            <path
                style={{ transform: "translate(0, 0px)", opacity: 0.3 }}
                fill="var(--blue)"
                d="M0,90L60,78.3C120,67,240,43,360,40C480,37,600,53,720,61.7C840,70,960,70,1080,58.3C1200,47,1320,23,1440,25C1560,27,1680,53,1800,65C1920,77,2040,73,2160,73.3C2280,73,2400,77,2520,73.3C2640,70,2760,60,2880,55C3000,50,3120,50,3240,43.3C3360,37,3480,23,3600,20C3720,17,3840,23,3960,33.3C4080,43,4200,57,4320,65C4440,73,4560,77,4680,65C4800,53,4920,27,5040,21.7C5160,17,5280,33,5400,41.7C5520,50,5640,50,5760,51.7C5880,53,6000,57,6120,55C6240,53,6360,47,6480,43.3C6600,40,6720,40,6840,38.3C6960,37,7080,33,7200,40C7320,47,7440,63,7560,73.3C7680,83,7800,87,7920,83.3C8040,80,8160,70,8280,61.7C8400,53,8520,47,8580,43.3L8640,40L8640,100L8580,100C8520,100,8400,100,8280,100C8160,100,8040,100,7920,100C7800,100,7680,100,7560,100C7440,100,7320,100,7200,100C7080,100,6960,100,6840,100C6720,100,6600,100,6480,100C6360,100,6240,100,6120,100C6000,100,5880,100,5760,100C5640,100,5520,100,5400,100C5280,100,5160,100,5040,100C4920,100,4800,100,4680,100C4560,100,4440,100,4320,100C4200,100,4080,100,3960,100C3840,100,3720,100,3600,100C3480,100,3360,100,3240,100C3120,100,3000,100,2880,100C2760,100,2640,100,2520,100C2400,100,2280,100,2160,100C2040,100,1920,100,1800,100C1680,100,1560,100,1440,100C1320,100,1200,100,1080,100C960,100,840,100,720,100C600,100,480,100,360,100C240,100,120,100,60,100L0,100Z"
            />
            </svg>

            <div className={`w-[100vw] bg-blue opacity-30 flex justify-between px-[6vw] pb-1`}>
            <span
                className="text-center font-montserrat cursor-pointer hover:scale-125 hover:opacity-100 active:scale-100 duration-300 my-4 md:m-0"
                onClick={handlePrevStep}
            >
                <img src="/images/logo/arrow_left.svg" alt="arrow-left" className={`w-[40px] h-[40px] ${isDarkMode ? "bg-opacity-50" : ""} m-2 transition-transform duration-300`}/>
            </span>
            <span
                className="text-center font-montserrat cursor-pointer hover:scale-125 hover:opacity-100 active:scale-100 duration-300 my-4 md:m-0"
                onClick={handleNextStep}
            >
                <img src="/images/logo/arrow_right.svg" alt="arrow-right" className={`w-[40px] h-[40px] ${isDarkMode ? "bg-opacity-50" : ""} m-2 transition-transform duration-300`}/>
            </span>
            </div>
                </div>
            </div>
        </div>
    </div>
  )
}
